import ApiService from '../api.service'
import getCurrentCompanyId from '../company.service'
import { IGrafanaDashboard, IGrafanaDashboardAccess } from '@/interfaces/api/grafana'

const GrafanaResource = {
  getDashboards: (): Promise<IGrafanaDashboard[]> => 
    ApiService.get(`/v1/companies/${getCurrentCompanyId()}/grafana_dashboards`),
    
  getDashboardById: (id: number): Promise<IGrafanaDashboard> =>
    ApiService.get(`/v1/companies/${getCurrentCompanyId()}/grafana_dashboards/${id}`),
    
  getDashboardAccessUrl: (id: number): Promise<IGrafanaDashboardAccess> =>
    ApiService.get(`/v1/companies/${getCurrentCompanyId()}/grafana_dashboards/${id}/access_url`)
}

export default GrafanaResource
